import { useEffect, useState } from 'react';
import FormGroup from './FormGroup';

function isValidUSZip(sZip) {
    return /^\d{5}(-\d{4})?$/.test(sZip);
}

const MAX_LENGTH = 5;

const InputZipcode = ({
    name,
    label,
    value: externalValue,
    isRequired,
    placeholder,
    inlineStyle,
    showError,
    externalErrorMessage,
    onChange = () => {},
}) => {
    const [isValid, setIsValid] = useState(true);
    const [value, setValue] = useState(externalValue);
    const [errorText, setErrorText] = useState('');
    const [locality, setLocality] = useState('');

    useEffect(() => {
        if (showError) {
            if (value.length === 0 && isRequired) {
                setErrorText('Zip Code is required');
            } else if (value.length < MAX_LENGTH) {
                setErrorText('Must be 5 digits');
            } else if (!isValid) {
                setErrorText('Invalid Zip Code');
            } else {
                setErrorText('');
            }
        }
    }, [showError, value, isValid]);

    const checkValidity = zip => zip.length === MAX_LENGTH && isValidUSZip(zip);

    const onZipChange = e => {
        const { value } = e.target;
        let zip = value.replace(/[^0-9]/g, '');
        zip = zip.slice(0, MAX_LENGTH);

        setValue(zip);
        const valid = checkValidity(zip);
        setIsValid(valid);
        onChange(e, valid);

        if (zip.length < MAX_LENGTH && locality) {
            setLocality('');
        }

        if (valid) {
            getCityFromZip(zip, e);
        }
    };

    const getCityFromZip = async (zip, event) => {
        try {
            const response = await fetch('/zipcode', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': window.Laravel.csrfToken,
                },
                body: JSON.stringify({ zipcode: zip }),
            });

            const {
                data: { city, state },
            } = await response.json();
            setLocality(`${city ? `${city}, ` : ''}${state}`);
        } catch (error) {
            console.warn('No city found for given zipcode', zip);
        }
    };

    const hasError = showError && (!isValid || externalErrorMessage);

    return (
        <FormGroup
            label={label}
            name={name}
            showError={hasError}
            externalErrorMessage={errorText || externalErrorMessage}
            required={isRequired}
        >
            <input
                value={value}
                type="text"
                inputMode="numeric"
                id={name}
                name={name}
                maxLength={MAX_LENGTH}
                className={`form-control${hasError ? ' error' : ''}`}
                placeholder={placeholder}
                style={inlineStyle}
                onChange={onZipChange}
                required={isRequired}
                aria-describedby={hasError ? `${name}-error` : null}
            />
            <div className="locality-container" style={{ width: inlineStyle.width || 'auto' }}>
                <span className="locality-text">{locality}</span>
            </div>
        </FormGroup>
    );
};

export default InputZipcode;
